import { createEntityFilterStore } from "./createEntityFilterStore";
import type { InvestmentFilters } from "@/domain/types";

const initialFilters: InvestmentFilters = {
	state: undefined,
	investor_uuid: undefined,
	promoter_uuid: undefined,
	investor_type: undefined,
	is_archived: false,
	amount_min: undefined,
	amount_max: undefined,
	search: "",
	sort: { key: undefined, direction: null },
};

export const useInvestmentFiltersStore =
	createEntityFilterStore<InvestmentFilters>(
		"InvestmentFiltersStore",
		initialFilters,
	);
